
import Mainroutes from './Routes/Mainroutes';


function App() {
  return (



    <div className="App">
     
     <Mainroutes/>
     {/* <Healthcare/> */}
     
   
     

    </div>
  );
}

export default App;